import { CURRENCY_PER_COUNTRY } from "@config/consts";
import { AVAILABLE_COUNTRIES } from "@typings/globals";
import { AppConfig } from "@typings/appConfig";

const config: AppConfig = {
  currency: CURRENCY_PER_COUNTRY[AVAILABLE_COUNTRIES.UK],
  booking: {
    commitments: {
      enabled: false,
    },
  },
  b2b: {},
  refRewardAmount: 20,
  welcomeRewardAmount: 20,
};

export { config as uk };
